import request from '@/utils/request'

export function listData(shareEid) {
    return request({
        url: `/tdcs/attachs/${shareEid}`,
        method: 'get'
    })
}

export function itemData(mavinEid) {
    return request({
        url: `/tdcs/attachs/array/${mavinEid}`,
        method: 'get'
    })
}